import {
  Component,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
  Input,
} from '@angular/core';

@Component({
  selector: 'app-line-loader',
  imports: [],
  templateUrl: './line-loader.component.html',
  styleUrl: './line-loader.component.css',
})
export class LineLoaderComponent implements OnInit, OnDestroy {
  @Input() sseConfig: any;
  countdown = 70;
  private countdownInterval: any;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.sseConfig && this.sseConfig.onTimeout) {
      const intervalMs = this.sseConfig.onTimeout.intervalMs || 5000;
      const maxAttempts = this.sseConfig.onTimeout.maxAttempts || 12;
      this.countdown = Math.round((intervalMs * maxAttempts) / 1000);
    } else {
      this.countdown = 70;
    }
    this.startCountdown();
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.cdr.detectChanges();
      } else {
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}
